<!--tab-->
<template>
 <div class="data-card-tab">
        <template v-for="(item,index) in tabList">
          <div :id="name+index" :key="index" :class="['data-card-tab-item',{'data-card-tab-active':curIndex==index}]"
            @click="switchTab(item,index)">{{item.name}}</div>
          <div class="data-card-tab-space" id="tab-space" :key="index+'space'"></div>
        </template>

        <div ref="line" class="data-card-tab-line"
          :style="'width:'+width+'px;transform:translateX('+left+'px);transition-duration: 0.3s;'"></div>
      </div>
</template>

<script>
    export default {
        components: {},
        props: {
            // 数据
            tabList: {
                type: Array,
                default: () => {
                    return []
                }
            },
            name: {
                type: String,
                default: ''
            }

        },
        data () {
            return {
                curIndex: 0,
                width: 0,
                left: 0
            }
        },
        computed: {

        },
        methods: {
            switchTab (item, index) {
                this.curIndex = index
                let length = 0
                for (let i = 0; i < this.tabList.length; i++) {
                    let tabDiv = document.querySelector('#' + this.name + i)
                    if (i < index) {
                        length += tabDiv.offsetWidth + document.querySelector('#tab-space').offsetWidth
                    } else if (i === index) {
                        this.$nextTick(() => {
                            this.width = tabDiv.offsetWidth
                        })
                    }
                }
                this.left = length
                this.$emit('onSwitch', item, index)
            }

        },
        mounted () {
            // this.switchTab({ 'code': '', 'name': '全部' }, 0)
        }

    }
</script>

<style scoped lang="less">
.data-card-tab {
        display: flex;
        margin-top: 24px;
        position: relative;

        &-item {

          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
        }

        &-space {
          width: 24px;
        }

        &-active {
          color: rgba(54, 179, 116, 1);
        }

        &-line {
          position: absolute;
          bottom: -6px;
          left: 0;
          z-index: 1;
          width: 56px;
          height: 2px;
          background: rgba(54, 179, 116, 1);
        }
      }
</style>
